export function ItemTitle({ item }) {
  return (
    <h2 className="font-bold text-xl flex justify-between items-center w-full">
      <span>{item.title}</span>
      {item?.SolutionButton && item.SolutionButton}
    </h2>
  );
}
